<template>
  <div v-if="outlets.length > 1 && outlets_expiring.length > 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets_expiring.length }} of your accounts are nearing their expiration date, and
          {{ outlets.length }} are already expired.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="outlets.length > 1 && outlets_expiring.length === 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets_expiring.length }} of your account has nearing for expiration date, and
          {{ outlets.length }} are already expired.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="outlets.length === 1 && outlets_expiring.length > 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets_expiring.length }} of your accounts are nearing their expiration date, and
          {{ outlets.length }} has already expired.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="outlets.length === 1 && outlets_expiring.length === 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets_expiring.length }} of your account has nearing for expiration date, and
          {{ outlets.length }} has already expired.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="outlets_expiring.length > 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets_expiring.length }} of your accounts are nearing their expiration date.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else-if="outlets.length > 1">
    <div
      class="box danger m-b-0 res"
      style="height: 55px;">
      <div class="box-body">
        <p>
          <i class="fa fa-exclamation-triangle m-r-sm"/>
          Dear {{ user.name }}, {{ outlets.length }} of your accounts are already expired.
          Please settle your outstanding payment in the <a href="/franchise/billing"> <b> Billing </b> </a> section
          immediately to prevent account suspension.
        </p>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="outlets.length === 1">
      <div
        class="box danger m-b-0 res"
        style="height: 55px;">
        <div class="box-body">
          <div
            v-for="item in outlets"
            :key="item.id">
            <p>
              <i class="fa fa-exclamation-triangle m-r-sm"/>
              Dear {{ user.name }}, your {{ item.name }} account has already expired.
              Please settle your outstanding payment immediately to regain access in the <a href="/franchise/billing">
              <b> Billing </b> </a> section
            </p>
          </div>
        </div>
      </div>
            
    </div>
    <div v-else-if="outlets_expiring.length === 1">
      <div
        class="box danger m-b-0 res"
        style="height: 55px;">
        <div class="box-body">
          <div
            v-for="item in outlets_expiring"
            :key="item.id">
            <p>
              <i class="fa fa-exclamation-triangle m-r-sm"/>
              Dear {{ user.name }}, your {{ item.name }} account will expire soon.
              Please settle your outstanding payment immediately to regain access in the <a href="/franchise/billing">
              <b> Billing </b> </a> section
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style>
@media (max-width: 1370px) {
    .res {
        height: 75px !important;
    }
}

@media (max-width: 600px) {
    .res {
        height: auto !important;
    }
}

.box-aest {
    padding-bottom: -10%;
}

.renewal-header-old {
    position: fixed;
    top: 3.5rem;
    left: 0;
    right: 0;
    margin: inherit;
    z-index: 1020;
}

.renewal-header ~ .app-body {
    padding-top: 7rem;
}
</style>

<script>
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            outlets: [],
            outlets_expiring: [],
            user: null,
        };
    },
    created() {
        this.read();
        this.read_expiring();
        this.user = Auth.user();
    },
    methods: {
        read() {
            axios
                .get(Laroute.route('franchise.vue.expiryoutlets'))
                .then(({ data }) => {
                    this.outlets = data.data;
                })
                .catch(err => console.error(err));
        },
        read_expiring() {
            axios
                .get(Laroute.route('franchise.vue.expirysoonoutlets'))
                .then(({ data }) => {
                    this.outlets_expiring = data.data;
                })
                .catch(err => console.error(err));
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/subscription-renewal/almost-expiry-announcement.vue